let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gSl1o"), load("4CfTY"), load("gctwz"), load("4drdS"), load("aIuOE")]).then(() => parcelRequire('56n4X'));